import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import axios from "helpers/API";
import { errorBackendMsg } from "helpers/helpers";
import * as Yup from "yup";
import { useFormik } from "formik";
import TurnoPdf from "../admin/turnos/templatePdf/TurnoPdf";
import MsgConfirmacion from "componentes/MsgConfirmacion";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { parserJsonTemplate } from "../admin/turnos/templatePdf/utilsPdf";
import DetalleTurno from "../admin/turnos/DetalleTurno";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyItems: "center",
    alignItem: "center",
    direction: "column",
    justify: "center",
    maxWidth: "100vw",
    paddingLeft: 20,
    paddingRight: 20,
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
  },
  input100: {
    width: "100%",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function VerTurno({ volver }) {
  //APIMENSAJE
  const [msg, setMsg] = useState(null);
  const [isError, setIsError] = useState(false);
  const [mostrarMensaje, setMostrarMensaje] = useState(false);
  const [variantColor, setVariantColor] = useState(false);
  const errorApi = (msg) => {
    setIsError(true);
    setMostrarMensaje(true);
    setMsg(msg);
  };
  const resetApiMensaje = () => {
    setMsg(null);
    setIsError(false);
    setMostrarMensaje(false);
  };
  const msgApi = ({ msg, info = false }) => {
    setMostrarMensaje(true);
    setIsError(false);
    setMsg(msg);
    if (info) {
      setVariantColor("info");
    }
  };
  // ==========
  const [modalConfirmar, setModalConfirmar] = useState(false);

  const cerrarModalConfirmar = () => setModalConfirmar(false);
  const mostrarModalConfirmar = () => setModalConfirmar(true);
  // Datos Formulario
  const [lugar, setLugar] = useState("");
  const [servicio, setServicio] = useState("");
  const [fecha, setFecha] = useState("");
  const [hora, setHora] = useState("");
  const classes = useStyles();
  const history = useHistory();
  // Flag
  const [datosTurno, setDatosTurno] = useState(null);
  const [datosCargados, setDatosCargados] = useState(false);
  // Datos turno cancelar
  const [idTurno, setIdTurno] = useState(false);
  const [dniSolicitante, setDniSolicitante] = useState(false);
  // API Mensaje
  const [mensajeError, setMensajeError] = useState("");
  const [modalExito, setModalExito] = useState(false);
  const [msgExito, setMsgExito] = useState("");
  const [cancelado, setCancelado] = useState(false);

  const handleClose = () => {
    setModalExito(false);
    if (cancelado) {
      history.push("/");
    }
  };
  const styles = {
    header: {
      backgroundColor: "var(--color-primario-mda)",
      color: "white",
    },
    headerLogo: {
      backgroundColor: "var(--color-primario-mda)",
      color: "white",
      margin: "auto",
    },
  };
  const consultarTurno = (json) => {
    resetApiMensaje();
    axios
      .post("/turnos/obtener", {
        nroTurno: json.nroTurno,
        nroDoc: json.nroDoc,
      })
      .then(function (response) {
        if (response.data) {
          if (response.data.error) {
            console.log("Aqui");
            errorApi(response.data.msg);
            msgApi({ msg: `Info: ${response.data.msg}`, info: true });
            setDatosTurno(null);
          } else {
            // Exito
            setDatosTurno(parserJsonTemplate(response.data));
          }
        } else {
          errorApi(errorBackendMsg(response));
        }
      })
      .catch(function (error) {
        errorApi(errorBackendMsg(error));
      });
  };

  const cancelarTurno = () => {
    resetApiMensaje();
    axios
      .post("/turnos/cancelar", {
        nroTurno: idTurno,
        nroDoc: dniSolicitante,
      })
      .then(function (response) {
        console.log("Ver respuesta", response.data);
        if (response.data) {
          if (response.data.error) {
            errorApi(response.data.msg);
          } else {
            // Exito
            console.log("Ver data turno cancelado", response.data);
            if (response.data.msg) {
              msgApi({ msg: `Info: ${response.data.msg}`, info: true });
            }
          }
        } else {
          errorApi(errorBackendMsg(response));
        }
      })
      .catch(function (error) {
        errorApi(errorBackendMsg(error));
      })
      .finally(function () {
        // Reinicio valores
        setIdTurno(false);
        setDniSolicitante(false);
        setLugar("");
        setServicio("");
        setFecha("");
        setHora("");
        setDatosCargados(false);
      });
  };

  const botonCancelarTurno = () => {
    cancelarTurno();
    cerrarModalConfirmar();
  };

  // Formato
  const esNegrita = (palabra) => palabra.includes("[");

  const eliminarBrackets = (palabra) => {
    const regex = /(\[)|(\])/g;
    const str = palabra.replace(regex, "");
    return str;
  };

  const guion = () => "-";

  const wrapperText = (str) => {
    const texto = str.trim();
    const palabras = texto.split(" ");
    let salida = "";
    palabras.forEach((palabra) => {
      if (esNegrita(palabra)) {
        salida += " <b>" + eliminarBrackets(palabra) + "</b> ";
      } else {
        salida += " " + palabra + " ";
      }
    });
    return "<div>" + guion() + salida + "</div>";
  };

  function parserFormatoImpresion(estructura) {
    if (!estructura) {
      return false;
    }
    estructura = JSON.parse(estructura);
    const itemsListado = estructura.items.map((item, index) => (
      <div
        key={index}
        dangerouslySetInnerHTML={{ __html: wrapperText(item) }}
      ></div>
    ));
    return (
      <>
        <div>
          <h5 className="text-center">
            <u>{estructura.titulo}</u>
          </h5>
          <div>{itemsListado}</div>
        </div>
      </>
    );
  }
  // Fin Formato

  function parserLeyenda1(estructura) {
    const itemsListado = estructura.items.map((item) => (
      <div>{`- ${item}`}</div>
    ));
    return (
      <>
        <div>
          <h4>{estructura.titulo}</h4>
          <div>{itemsListado}</div>
        </div>
      </>
    );
  }
  const validationSchema = Yup.object({
    nroDoc: Yup.number()
      .required("Campo requerido")
      .typeError("El DNI tiene que ser un número")
      .min(1000000, "DNI Incorrecto")
      .max(99999999, "DNI Incorrecto"),
    nroTurno: Yup.number()
      .typeError("El número de turno tiene que ser un número")
      .required("Campo requerido"),
  });

  const formik = useFormik({
    initialValues: {
      nroTurno: "",
      nroDoc: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log("a")
      setDatosTurno(null)

      setDatosTurno({nroDoc: values.nroDoc, nroTurno: values.nroTurno})
    },
  });
  return (
    <>
      {modalConfirmar && (
        <MsgConfirmacion
          setVisible={setModalConfirmar}
          titulo="Cancelar Turno"
          msg={
            "¿Está seguro de cancelar su turno? Esta acción no es reversible"
          }
          aceptar={() => {
            cancelarTurno();
          }}
        />
      )}
      <Dialog
        open={modalExito}
        TransitionComponent={Transition}
        onClose={handleClose}
      >
        <DialogTitle>Ver Turno</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {msgExito}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose()} color="secondary">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
      <div>
        <form onSubmit={formik.handleSubmit}>
          <Grid container className={classes.root} spacing={1}>
            <hr />

            <Grid item md={12} xs={12}>
              <Typography variant="h4">Ver Turno</Typography>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              style={{ textAlign: "center", marginTop: 20 }}
            >
              <TextField
                variant="outlined"
                className={classes.input100}
                label="Número de Turno"
                type="text"
                id="nroTurno"
                name="nroTurno"
                value={formik.values.nroTurno}
                onChange={formik.handleChange}
                error={
                  formik.touched.nroTurno && Boolean(formik.errors.nroTurno)
                }
                helperText={
                  "Lo podes encontrar en el comprobante que fue enviado a tu email"
                }
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              style={{ textAlign: "center", marginTop: 20 }}
            >
              <TextField
                variant="outlined"
                className={classes.input100}
                label="DNI"
                type="text"
                id="nroDoc"
                name="nroDoc"
                value={formik.values.nroDoc}
                onChange={formik.handleChange}
                error={formik.touched.nroDoc && Boolean(formik.errors.nroDoc)}
                helperText={formik.touched.nroDoc && formik.errors.nroDoc}
              />
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 10,
              }}
            >
              <Grid item md={12} xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    volver()
                    history.push("/")
                  }}
                >
                  Volver
                </Button>
              </Grid>
              <Button type="submit" variant="contained" color="secondary">
                Buscar
              </Button>
            </Grid>
          </Grid>
        </form>
        {datosTurno && (
          <Grid container>
            <DetalleTurno nroDoc={datosTurno.nroDoc} nroTurno={datosTurno.nroTurno} />
          </Grid>
        )}
      </div>
    </>
  );
}

export default VerTurno;
